import { postRequest } from '../../../shared/utils';

export async function unblockPO(screenGridId) {
  const body = {
    screenGridId,
    functionName: 'npi_unblock_po_trigger_function',
    returnResult: 'result_text',
  };
  const { data, errors } = await postRequest('/api/triggerFunction', body);
  if (errors) {
    return { errors };
  }

  return data;
}
